__turbopack_context__.v({
  "content": "HhlHsG_content",
  "description": "HhlHsG_description",
  "limit": "HhlHsG_limit",
  "preview": "HhlHsG_preview",
  "toggle": "HhlHsG_toggle",
});
